import { CustomToast, ToastProvider, ToastViewport } from '@kit/ui'
import type { ToastProviderProps, ToastViewportProps, CustomToastProps } from '@kit/ui'

interface KitToastProviderProps extends ToastProviderProps {
  viewportProps?: ToastViewportProps
  toastProps?: CustomToastProps
}
export function KitToastProvider({
  children,
  viewportProps,
  toastProps,
  ...props
}: KitToastProviderProps) {
  return (
    <ToastProvider {...props}>
      {children}
      <ToastViewport {...viewportProps} />
      <CustomToast {...toastProps} />
    </ToastProvider>
  )
}
